<template lang="pug">
  .image-slider
    h2.image-slider__heading {{ settings.heading }}
    h3.image-slider__sub-heading {{ settings.sub_heading }}
    VueSlickCarousel.image-slider__slider(
      v-bind="sliderSettings"
    )
      template( #prevArrow="arrowOption" )
        icon-button(icon="arrow-left" size="20px")
      .image-slider__slide(
        v-for="slide, index in slides"
        :key="`image-slider_${_uid}_slide${index}`"
        @click="navigate(slide.link, $event)"
      )
        img.image-slider__image(
          :src="slide.src"
          :alt="slide.alt"
          draggable="false"
        )
      template( #nextArrow="arrowOption" )
        icon-button(icon="arrow-right" size="20px")
    base-button(:href="settings.cta_url" v-if="settings.cta_url") {{ settings.cta_text }}
</template>

<script>
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';
  import IconButton from 'scripts/components/buttons/IconButton.vue';
  import VueSlickCarousel from 'vue-slick-carousel';

  export default {
    name: 'ImageSlider',
    components: {
      BaseButton,
      IconButton,
      VueSlickCarousel,
    },
    props: {
      settings: Object,
      slides: {
        type: Array,
        default: () => [
          {
            image: String,
            imageAlt: String,
            link: String,
          },
        ],
      },
    },
    data() {
      return {
        sliderSettings: {
          arrows: true,
          dots: false,
          infinite: true,
          speed: 500,
          centerMode: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        },
      };
    },
    methods: {
      navigate(link, event) {
        const centerSlide = event.currentTarget.closest('.slick-slide.slick-center');
        if (centerSlide) window.location.href = link;
      },
    },
  };
</script>

<style lang="scss">
  .image-slider {
    position: relative;
    padding: 60px 0 100px;
    overflow: hidden;
    text-align: center;
    border-top: $border-width solid $color-orange;

    @include tablet-up {
      .slick-slide {
        transition: transform 0.5s ease, opacity 0.5s ease;
        opacity: 0.5;
      }
      .slick-slide.slick-center {
        opacity: 1;
        transform: scale(1.4);
      }
    }

    .slick-prev {
      left: 25px;
      transform: rotate(180deg);

      @include desktop-up {
        left: 50%;
        transform: translateX(-160px) rotate(180deg);
      }
    }

    .slick-next {
      right: 25px;
      transform: rotate(0);

      @include desktop-up {
        right: 50%;
        transform: translateX(160px);
      }
    }

    .slick-next,
    .slick-prev {
      position: absolute;
      top: -41px;

      @include desktop-up {
        top: -48px;
      }
    }

    .button--icon {
      background-color: $color-orange;
      border-radius: 50px;

      &:before {
        display: none;
      }
    }
  }

  .image-slider__heading {
    margin-bottom: 30px;
    font-family: $font-secondary;
    font-size: 48px;
    font-weight: 700;

    @include tablet-up {
      font-size: 96px;
    }
  }

  .image-slider__sub-heading {
    color: $color-orange;
    font-size: rem(27);
    font-weight: 700;
    text-transform: uppercase;
  }

  .image-slider__slider {
    position: relative;
    padding: 10% 0;
  }

  .image-slider__slide {
    cursor: pointer;
  }
</style>
